import React from 'react';
import EmptyRecord from '@/components/EmptyRecord';

const NoData = ({ text = <p>当前状态暂无记录</p>, img, className }) => (
  <EmptyRecord img={img} text={text} className={className} />
);
export default NoData;
